export const USERS_ADMIN_PERMISSION = "users:admin";
export const USERS_READ_PERMISSION = "users:read";
export const BODYCAM_MANAGE_PERMISSION = "bodycam:manage";
export const API_KEYS_MANAGE_PERMISSION = "api_keys:manage";
export const WIDGETS_API_KEYS_MANAGE_PERMISSION = "widgets:api-keys:manage";
export const WIDGETS_USERS_TABLE_MANAGE_PERMISSION = "widgets:users-table:manage";

export function canManageUsers(permissions: string[]): boolean {
  return permissions.includes(USERS_ADMIN_PERMISSION);
}

export function canManageBodycam(permissions: string[]): boolean {
  return permissions.includes(BODYCAM_MANAGE_PERMISSION);
}

export function canReadUsers(permissions: string[]): boolean {
  // For now, we assume that if you can manage users, you can also read them.
  return permissions.includes(USERS_READ_PERMISSION) || canManageUsers(permissions);
}

export function canManageWidgetApiKeys(permissions: string[]): boolean {
  return permissions.includes(WIDGETS_API_KEYS_MANAGE_PERMISSION);
}

export function canManageWidgetUsersTable(permissions: string[]): boolean {
  return permissions.includes(WIDGETS_USERS_TABLE_MANAGE_PERMISSION);
}
